<template>
  <modal
    v-if="showModal"
    :size="size"
    @close="onClick">
    <div
      slot="header"
      class="m-auto">
      <div class="alert-icon-wrapper m-auto">
        <i class="fas fa-exclamation-circle"/>
      </div>
    </div>
    <div slot="body">
      <p
        class="font-weight-normal"
        v-html="$t(alert.msg, alert.args)" />
    </div>
    <div slot="footer">
      <ActionButton
        class-name="btn btn-lg btn-primary btn-block"
        @click="onClick">{{ $t("ALERT.OK") }}</ActionButton>
    </div>
  </modal>
</template>

<script>
import Modal from './Modal';
import ActionButton from '@/components/Actions/ActionButton';

export default {
  name: 'AlertModal',
  components: {
    Modal,
    ActionButton,
  },
  props: {
    size: {
      type: String,
      default: 'sm',
    },
    alert: {
      type: Object,
      default: () => {},
    },
    showModal: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClick() {
      this.$store.commit('alerts/resetAlert');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.fa-exclamation-circle {
  color: $secondary;
  font-size: 80px;
}

p:last-child {
  margin-bottom: 0;
}
</style>
